import React, { useState, useEffect } from 'react';
import * as api from '../services/api'
import Loader from '../../components/Loader';
import styles from './manager.module.css';
import back from '../../assets/icons/back.svg';
import InsertBar from '../../components/InsertBar';
import CustomizedModal from '../../components/modal/CustomizedModal';
import { Box, Button } from '@mui/material';
import { useNavigate, useLocation } from "react-router-dom";

import { useSelector } from 'react-redux';
import { getUser } from 'store/authSlice';

function DepartmentEdit() {
  const [loading, setLoading] = useState(false)
  const location = useLocation();
  const navigate = useNavigate();
  const department_code = useState(location.state.department_code);
  const [department_name, setDepartmentName] = useState(location.state.department_name);
  const [department_name_short, setDepartmentNameShort] = useState(location.state.department_name_short);
  const [number_of_people, setNumberOfPeople] = useState(location.state.number_of_people);
  const [info, setInfo] = useState({});
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const user = useSelector(getUser);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const res = await api.findDepartment(null, null, department_code);
    setLoading(false);
    if (res) {
      if (res['data']['code'] === 200) {
        setInfo(res['data']['data'][0]);
      } else {
        //alert(res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }
  };

  const handlePrevious = () => {
    navigate('/departmentManager');
  };

  const handleError = (msg) => {
    setErrorMessage(msg);
    setShowUpdateModal(false);
  };

  const handleUpdate = async () => {
    if (!department_name.trim() || !department_name_short.trim()) {
      handleError("กรุณากรอกข้อมูลให้ครบถ้วน");
      return;
    }
    setShowUpdateModal(true);
  };
  
  const confirmedUpdate = async () => {
    let body = { ...info };
    body.department_name = department_name;
    body.department_name_short = department_name_short;
    body.number_of_people = number_of_people;
    body.updated_date = new Date().toISOString();
    body.updated_user = JSON.parse(localStorage.getItem('userData'))?.uid;
  
    setLoading(true);
    const res = await api.updateDepartment(body);
    setLoading(false);
  
    if (res) {
      if (res['data']['code'] === 200) {
        setShowUpdateModal(false); 
        handlePrevious() //navigate
      } else {
        handleError(res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }
  };
  
  const handleCloseModal = () => {
    setShowUpdateModal(false);
  };

  const handleCloseErrorModal = () => setErrorMessage(null);


  return (
    <>
      <Loader loading={loading} />
      {showUpdateModal && (
        <CustomizedModal
          onClose={handleCloseModal}
          apiCall={confirmedUpdate}
          confirmMessage={`ยืนยันที่จะแก้ไขข้อมูล`}
          confirmButtonText={`ยืนยัน`}
        />
      )}
      {errorMessage && (
        <CustomizedModal
          onClose={handleCloseErrorModal}
          confirmMessage={errorMessage}
          apiCall={handleCloseErrorModal} // No action required, just closes
          confirmButtonText={`ตกลง`}
        />
      )}
      <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={handlePrevious}>
        <img src={back} alt="Previous" className={styles.directIcon} />
        กลับไป จัดการสังกัด
      </Box>
      <Box className={styles.head1Text}>แก้ไขข้อมูลสังกัด</Box>
      <Box sx={{ border: '1.4px solid #478F96', borderRadius: 2, padding: 4, marginTop: '18px' }}>
        <Box className={styles.head2Text}>ชื่อสังกัด</Box>
        <InsertBar
          currentValue={department_name}
          setNewValue={setDepartmentName}
          placeholder="ชื่อสังกัด"
        />
        <Box className={styles.head2Text} sx={{ marginTop: 1 }}>ตัวย่อชื่อสังกัด</Box>
        <InsertBar
          currentValue={department_name_short}
          setNewValue={setDepartmentNameShort}
          placeholder="ตัวย่อชื่อสังกัด"
        />
        <Box className={styles.head2Text} sx={{ marginTop: 1 }}>จำนวนกำลังพล</Box>
        <InsertBar
          currentValue={number_of_people}
          setNewValue={(value) => {
            if (/^\d*$/.test(value)) {
              setNumberOfPeople(value ? Number(value) : 0);
            }
          }}  
          placeholder="จำนวนกำลังพล"
        />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2, marginRight: 4.3 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleUpdate}
          sx={{ padding: 1, borderRadius: 1.5 }}
        >
          <p style={{ fontWeight: 600, margin: 0, fontSize: 12, padding: '0 40px' }}>บันทึก</p>
        </Button>
      </Box>
    </>
  );
}

export default DepartmentEdit;
